import moment from 'moment';

// Lightweight SchedulerLog entity wrapper with PascalCase fields only.
// Corresponds to WaveWise.WebApp.Models.Responses.SchedulerLog.
export default class SchedulerLog {
  constructor(data) {
    this.Id = data.Id;
    this.Tag = data.Tag || '';
    this.Level = data.Level || '';
    this.Message = data.Message || '';
    this.Exception = data.Exception || null;

    // Handle timestamp fields with moment.js.
    // Accepts a raw UTC string from the API or an existing moment object
    // (e.g. when re-constructing).
    if (data.Timestamp !== undefined) {
      this.Timestamp = (data.Timestamp === null) ? null
        : moment.isMoment(data.Timestamp) ? data.Timestamp
        : moment.utc(data.Timestamp);
    }
  }

  // Return formatted local time string for display.
  getFormattedTimestamp() {
    return this.Timestamp ? this.Timestamp.local().format('L LTS') : '';
  }
}